import Vue from 'vue'
import VueI18n from 'vue-i18n'
import en from './en'
import es from './es'

const messages = {
  en,
  es
}

Vue.use(VueI18n)

export default new VueI18n({
  locale: sessionStorage.getItem('language') || process.env.VUE_APP_LANG_DEFAULT, // set default locale
  messages
})

// Hot updates
if (module.hot) {
  module.hot.accept(['./en', './es'], function () {
    i18n.setLocaleMessage('en', require('./en').default)
    i18n.setLocaleMessage('es', require('./es').default)
  })
}
